<template>
  <CancelFlowRedesignExperiment>
    <template #default>
      <CancelPage/>
    </template>
    <template #redesign>
      <CancelRedesign/>
    </template>
  </CancelFlowRedesignExperiment>
</template>
<script setup>
import CancelFlowRedesignExperiment from '@/components/account/membership/new/CancelFlowRedesignExperiment.vue'
import CancelPage from '@/components/account/membership/CancelPage.vue'
import CancelRedesign from '@/views/account/CancelPage.vue'
</script>
